import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast, Slide } from 'react-toastify';

//3rd party
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css';
import moment from 'moment';
import { TailSpin, Watch } from  'react-loader-spinner';
import Backdrop from '@mui/material/Backdrop';
import * as Icon from 'react-bootstrap-icons';

//Functions
import { apiCall, apiError } from '../functions/common';

//Components
import Header from '../components/Header';
import BottomMenu from '../components/BottomMenu';
import LeaveRequestRow from '../components/LeaveRequestRow';
import DayRowSkeleton from '../components/DayRowSkeleton';
import Button from '../components/Button';
import ModalLeaveRequest from '../components/ModalLeaveRequest';
import ModalRemoveRequest from '../components/ModalRemoveRequest';

//Styles
import '../css/leave-request.css';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const LeaveRequest = () => {
    const { t, loading: i18nLoading } = useTranslations();

    const navigate = useNavigate();
    const loggedIn = localStorage.getItem('ingelogd');
    const code = global.settings.api.code;

    //Variables
    const [showSkeletonLeaveRequest, setShowSkeletonLeaveRequest] = useState(true);
    const [loadingLeaveRequests, setLoadingLeaveRequests] = useState(false);
    const [leaveRequests, setLeaveRequests] = useState(null);
    const [statuses, setStatuses] = useState(null);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [statusId, setStatusId] = useState(null);
    const [statusName, setStatusName] = useState(null);

    const [showAanvraagModal, setShowAanvraagModal] = useState(0);
    const [showModal, setShowModal] = useState(0);
    const [modalData, setModalData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        if (loggedIn !== 'true') { navigate('/login') };

        getLeaveRequests();
    }, []);

    const renderAanvraagModal = (/*id, statusId*/) => {
        /*const obj = {
            id: id,
            status_id: statusId
       }
        setModalData(obj); */
        setShowAanvraagModal(showAanvraagModal + 1);
    }

    const renderModal = (id) => {
        const obj = {
            id: id,
        }
        setModalData(obj);
        setShowModal(showModal + 1);
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const submitDate = null;

    //LeaveRequestaanvragen
    const getLeaveRequests = async (newStatusId = null, type = null) => {
        //setOpenBackdrop(true);
        setLoadingLeaveRequests(true);
        if (type === 'skeleton') { setShowSkeletonLeaveRequest(true) }

        try {
            const response = await apiCall(`verlofaanvragen?code=${code}&status_id=${newStatusId}`);
            // Success
            if (response.data.success) {
                const data = response.data.data;
                setLeaveRequests(data.verlofaanvragen);
                setStatuses(data.verlofaanvraag_statussen);
                
                setOpenBackdrop(false);
                setShowModal(false);
                setShowAanvraagModal(false);
                setShowSkeletonLeaveRequest(false);
                setLoadingLeaveRequests(false);
            }
        } catch (error) {
            // Error
            apiError(error);
        }
    }

    const changeStatus = (newStatusId, newStatusName) => {
        //Als je 2x op dezelfde drukt, dan het filter resetten

        if(newStatusId == statusId){
            newStatusId = null;
            newStatusName = null;
        }

        setStatusId(newStatusId);
        setStatusName(newStatusName);
        getLeaveRequests(newStatusId);
    }

    const deleteRow = async (id) => {
        setOpenBackdrop(true);
        //Call API
        try {
            const response = await apiCall(`verlofaanvraag/${id}/intrekken?code=${code}`, 'post');

            // Success
            if (response.data.success) {
                //getRegistrations(submitDate);
                getLeaveRequests();
            }
            setOpenBackdrop(false);
        } catch (error) {
            // Error
            apiError(error);
        }
    }

    console.log(statuses);

    return(
        <div>
            <Header />
            <div className="main">
                <div className="container">
                    <div className="content">
                        <div className="register">
                            <div className="status-filter">
                                <h2>{t('leave_of_absence', 'Leave of absence')}</h2>
                                {
                                    statuses ?
                                        statuses.map((option, index) => {
                                            return <Button
                                                key={index}
                                                text={option.label}
                                                onClick={() => changeStatus(option.id, option.label)}
                                                style={statusId != option.id ? {backgroundColor: '#ffffff', border: `1px solid ${option.kleur}`, color: option.kleur } : {backgroundColor: option.kleur, border: `1px solid ${option.kleur}`}}
                                                //active={statusId == option.id ? 1 : 0}
                                            />
                                        })
                                    :
                                    null
                                }
                            </div>
                            <div className="days-leave-request">
                                <div className="days-heading">
                                    <h3>
                                        {t('leave_requests', 'Leave requests')} {statusName ? `- ${statusName}` : null}
                                    </h3>
                                    <span className="add-leave-request" onClick={() => {renderAanvraagModal(); handleClose()}}><Icon.Plus /></span>
                                    {
                                        loadingLeaveRequests ?
                                        <Watch
                                            height="20"
                                            width="20"
                                            radius="48"
                                            color="white"
                                            ariaLabel="watch-loading"
                                            wrapperStyle={{}}
                                            wrapperClassName=""
                                            visible={true}
                                        />
                                        :
                                        null
                                    }
                                </div>
                                <div className="day-rows">
                                    {
                                        showSkeletonLeaveRequest ?
                                            <div className="skeletons-hours">
                                                <DayRowSkeleton />
                                                <DayRowSkeleton />
                                                <DayRowSkeleton /> 
                                            </div>
                                        :
                                        <div>
                                        {
                                            leaveRequests ?
                                                leaveRequests.map((option, index) => {
                                                    return <LeaveRequestRow 
                                                        key={index}
                                                        id={option.id}
                                                        option={option}
                                                        statusId={option.status_id}
                                                        status={option.status}
                                                        verwijderen={option.verwijderen}
                                                        date={option.datum_aanvraag}
                                                        startDate={option.startdatum}
                                                        endDate={option.einddatum} 
                                                        comment={option.opmerking}
                                                        commentRejected={option.opmerking_afgewezen}
                                                        uren={option.uren}
                                                        deleteRow={deleteRow}
                                                        renderModal={renderModal} />
                                                    })
                                            :
                                            <p className="no-registrations">{t('no_results', 'No results')}</p>
                                        }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BottomMenu />

            {/* Backdrop */}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openBackdrop}>
                <Watch
                    height="80"
                    width="80"
                    radius="48"
                    color="white"
                    ariaLabel="watch-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                />
            </Backdrop>

            {/* Modal to apply for a leave request */}
            {
                showAanvraagModal > 0 ?
                <ModalLeaveRequest show={showAanvraagModal} data={modalData} getLeaveRequests={getLeaveRequests} />
                :
                null
            }

            {/* Modal to apply for a leave request removal */}
            {
                showModal > 0 ?
                <ModalRemoveRequest show={showModal} data={modalData} getLeaveRequests={getLeaveRequests} />
                :
                null
            }
            <ToastContainer transition={Slide}/>
        </div>
    );
}

export default LeaveRequest;